module.exports = __webpack_public_path__ + "img/level_five_hover.afca5478.png";